import { MessageType } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

/** PC_PING MessageType */
export class PingMessage extends BaseMessage {
    constructor() {
        super();
        this.header.command = MessageType.PC_PING;
    }
}

/** PC_PONG MessageType */
export class PongMessage extends BaseMessage {
    public deserializeBody(memoryBuffer: MemoryBuffer): void {
        // We don't need to do anything with the PONG packet.
        // Leaving this method, so at least we can track it if needed at some point
    }
}
